import { Skeleton } from "@mui/material";
import { useRecordContext } from "react-admin";
import GroupCertificationEditFormSite from "./GroupCertificationEditFormSite";
import GroupCertificationEditFormGroup from "./GroupCertificationEditFormGroup";

const GroupCertificationEditForm = () => {
  const record = useRecordContext();
  if (!record) {
    return <Skeleton variant="text" width="100%" height={40} />;
  }

  if (record.group_type === "fingrid_site") {
    return <GroupCertificationEditFormSite />;
  }
  return <GroupCertificationEditFormGroup />;
};

export default GroupCertificationEditForm;
